<template lang="">
    <div>
        estamos en construccion    
    </div>
</template>
<script>
export default {
    
}
</script>